import { LinkedinIcon as LinkedIn, Mail } from "lucide-react";
import "./index.css";

const directors = [
  {
    name: "MUHAMMAD HAMMAD ARSHAD",
    position: "Director /Chief Executive Officer",
    image: "/img/MUHAMMAD-HAMMAD-ARSHAD-300x300.jpg",
    bio: "Muhammad Hammad Arshad is CIA and MBA have attained excellent exposure of Regulatory Developments / Compliance assurance in Stock Market over 11 years and have the experience of implementation of SEC Ordinance, SEC, Rules and Capital Market Intermediaries Regulations. Mr. Mian has the vast expertise in brokerage business management, mutual funds management, corporate matters and statutory compliance. In-depth knowledge and vast understanding of Corporate Laws, Tax Laws and Accounting Standards along with the practical experience of working on key positions has made him top ranking professional. Enthusiasm & drive coupled with vast experience is the reason to be an energetic & pro-active professional. Mr. Hammad has also participated in many international investment conferences and represented Pakistan in UAE. Before joining OSPL in March, 2022, He had served in the DMCC (Dubai Multi Commodities Centre) UAE on the key positions.",
  },

  {
    name: "MRS. JAMNA DEVI REENA KUMARI",
    position: "Director /Company Secretary",
    image: "/img/JAMNA-DEVI-300x300.jpg",
    bio: "Mrs. Jamna Devi Reena Kumari is MBA in finance. Blended with entrepreneurial mind and convinced with the capital markets of Pakistan she founded Orbit Securities Limited in 2022. Her vast experience of trading in the capital markets of Pakistan laid a strong foundation for Orbit Securities Private Limited. She possesses unique insight into the working of stock market with major exposure of capital market of Pakistan. Over the years the clients in capital market have taken a lot of benefit from her expertise in capital market operations that includes dealing in equities, sales and marketing strategies, financial advisory and customer relationships. Before joining OSPL, She had served in the many capital market companies and listed company on the key positions.",
  },
  // Add more directors as needed
];

export default function BoardOfDirectors() {
  return (
    <div className="board-container">
      <div className="hero-section">
        <div className="">
          <h1 className="hero-title">BOARD OF DIRECTORS</h1>
        </div>
      </div>

      <div className="content-section">
        <p className="intro-text">
          Our Board of Directors brings together a wealth of experience and
          expertise in the financial services industry. Their leadership and
          vision guide our company towards continued success and growth.
        </p>

        <div className="directors-grid">
          {directors.map((director, index) => (
            <div key={index} className="director-card">
              <div className="director-image-container">
                {/* <img
                  src={director.image || "/placeholder.svg"}
                  alt={director.name}
                  className="director-image"
                /> */}
              </div>
              <div className="director-info">
                <h2 className="director-name">{director.name}</h2>
                <h3 className="director-position">{director.position}</h3>
                <p className="director-bio">{director.bio}</p>
                {/* <div className="director-links">
                  <a
                    href={director.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="director-link"
                  >
                    <LinkedIn size={20} />
                  </a>
                  <a
                    href={`mailto:${director.email}`}
                    className="director-link"
                  >
                    <Mail size={20} />
                  </a>
                </div> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
